import { GetMarkets200Response, SideResponse } from "../../../codegen-api";
import { OrderbookLayoutEnum } from "./shared";

export enum OrderbookTradeHistoryType {
  ORDERBOOK = "orderbook",
  TRADES = "trade_history",
}

export interface ITradeOrderbookSectionProps {
  onOrderbookRowClick: (
    price: string,
    size: string,
    side: SideResponse,
  ) => void;
  perpInstrument?: GetMarkets200Response;
  layout?: OrderbookLayoutEnum;
  onLayoutChange?: (layout: OrderbookLayoutEnum) => void;
}
